import React, { useMemo, useState, useEffect } from "react";
import { format } from "date-fns";
import CurFt from "../../components/CurFt";
import Filters from "./Filters";
import WhatsAppShare from "../../components/WhatsAppShare";
import FlightProposalShare from "../../components/FlightProposalShare";
import {
  ArrowUpDown,
  Share2,
  Plane,
  BaggageClaim,
  TicketX,
  Ticket,
  Utensils,
  TicketCheck,
  Armchair,
  Eye, EyeOff
} from "lucide-react";
import { toast } from 'react-hot-toast';
function parseTimeToMinutes(t) {
  // "20:15" -> 1215
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
}
function parseDurationToMinutes(d) {
  // "5h 25m" -> 325
  const [h, m] = d.replace("m", "").split("h").map((x) => x.trim());
  return Number(h || 0) * 60 + Number((m || "0").replace("m", "").trim() || 0);
}

export default function OneWayResult(props) {
  const {
    outbound,
    FormData,
    handleBookNow,
    handlFlightDeatils,
    FiltStop,
    FiltPrice,
    FiltAirline,
    FiltFareClassOutbound,
    handleChangeStops,
    applyFilters,
    handleChangeAirlines,
    priceRangeFilter,
    PriceRange,
    selectedDeparture,
    selectedArrival,
    handleChangeDeparture,
    setSelectedDeparture,
    handleChangeArrival,
    setSelectedArrival,
    handleChangeFarepol,
    selectedFarepol,
    handleFareClassOutbound,
    user,
    onShare,
    onSetShare,
  } = props
  const [outBoundData, setoutBoundData] = useState(outbound);
  const [sortKey, setSortKey] = useState("price");
  const [sortDir, setSortDir] = useState("asc"); // 'asc' | 'desc'

  const sorted = useMemo(() => {
    const arr = [...outbound];
    arr.sort((a, b) => {
      const dir = sortDir === "asc" ? 1 : -1;
      switch (sortKey) {
        case "airline":
          return a.AirlineName.localeCompare(b.AirlineName) * dir;
        case "departure":
          return (parseTimeToMinutes(format(new Date(a.FromUTCTime), "HH:mm")) -
            parseTimeToMinutes(format(new Date(b.FromUTCTime), "HH:mm"))) * dir;
        case "duration":
          return (parseDurationToMinutes(a.Duration) -
            parseDurationToMinutes(b.Duration)) * dir;
        case "arrival":
          return (parseTimeToMinutes(format(new Date(a.ToUTCTime), "HH:mm")) -
            parseTimeToMinutes(format(new Date(b.ToUTCTime), "HH:mm"))) * dir;
        case "price":
        default:
          return (a.PubFare - b.PubFare) * dir;
      }
    });
    return arr;
  }, [outbound, sortKey, sortDir, outBoundData]);


  const handleSort = (key) => {
    if (key === sortKey) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortKey(key);
      setSortDir("asc");
    }
  };
  const [openEye, setOpenEye] = useState(false);
  const [showProposalPopup, setshowProposalPopup] = useState(false);
  useEffect(() => {
    if (selectedFlights.length === 0 && onShare) {
      setshowProposalPopup(false)
      onSetShare(false)
      toast.error('Select atleast 1 flight', { autoClose: 3000 });
    } else {
      setshowProposalPopup(onShare)
    }
  }, [onShare]);
  const [contactInfo, setContactInfo] = useState({
    name: '',
    mobile: '',
    email: ''
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setContactInfo(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmitSelectedFlights = () => {
    setContactInfo({ name: '', mobile: '', email: '' });
    setSelectedFlights([]);

    // Add your API call or further processing here
  };
  const [selectedFlights, setSelectedFlights] = useState([]);

  const handleShareSelection = (flight, PriceID, isSelected) => {

    if (isSelected) {
      // Find the selected fare based on PriceID
      const selectedFare = flight.FareList?.find(
        fare => fare.PriceID === PriceID
      );

      if (!selectedFare) {
        console.log("Fare not found for PriceID:", PriceID);
        return;
      }

      // Store flight + selected fare
      const selectedFlight = {
        ...flight,
        FareList: [selectedFare],
        selectedPriceID: PriceID,
      };

      setSelectedFlights(prev => [...prev, selectedFlight]);
    } else {
      setSelectedFlights(prev =>
        prev.filter(f => f.selectedPriceID !== PriceID)
      );
    }
  };

  // const isFlightSelected = (flight) => {
  //   return selectedFlights.some(f => f.keyIndex === flight.keyIndex);
  // };
  const isFlightSelected = (flight, PriceID) => {
    return selectedFlights.some(
      f =>
        f.keyIndex === flight.keyIndex &&
        f.selectedPriceID === PriceID
    );
  };
  const handleExtraMarkup = (index, field, value) => {
    setSelectedFlights((prevFlights) =>
      prevFlights.map((flight, i) => {
        if (i !== index) return flight;

        const extraMarkup = parseFloat(value) || 0;

        const originalPublishedFare =
          flight.OriginalPublishedFare ??
          flight.FareList?.[0]?.PublishedFare ??
          0;

        return {
          ...flight,

          [field]: value,

          OriginalPublishedFare: originalPublishedFare,

          FareList: flight.FareList.map((fare, fareIndex) =>
            fareIndex === 0
              ? {
                ...fare,
                PublishedFare: originalPublishedFare + extraMarkup,
              }
              : fare
          ),
        };
      })
    );
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 p-4">
      {/* Sidebar (sticky + scrollable) */}
      <Filters
        setOpenEye={setOpenEye}
        openEye={openEye}
        data={outbound}
        FormData={FormData}
        FiltStop={FiltStop}
        outBoundData={outBoundData}
        setoutBoundData={setoutBoundData}
        FiltPrice={FiltPrice}
        FiltAirline={FiltAirline}
        handleChangeStops={handleChangeStops}
        applyFilters={applyFilters}
        handleChangeAirlines={handleChangeAirlines}
        priceRangeFilter={priceRangeFilter}
        PriceRange={PriceRange}
        selectedDeparture={selectedDeparture}
        selectedArrival={selectedArrival}
        handleChangeDeparture={handleChangeDeparture}
        setSelectedDeparture={setSelectedDeparture}
        handleChangeArrival={handleChangeArrival}
        setSelectedArrival={setSelectedArrival}
        setshowProposalPopup={setshowProposalPopup}
        showProposalPopup={showProposalPopup}
        selectedFarepol={selectedFarepol}
        handleChangeFarepol={handleChangeFarepol}
        handleFareClassOutbound={handleFareClassOutbound}
        FiltFareClassOutbound={FiltFareClassOutbound}
      />

      {/* Results */}
      <main className="w-full md:w-3/4 space-y-4">
        {/* Column headers with sorting */}
        <div className="hidden md:grid grid-cols-12 px-4 py-2 text-sm font-semibold text-gray-700">
          <SortHead title="Airline" onClick={() => handleSort("airline")} active={sortKey === "airline"} dir={sortDir} className="col-span-4" />
          <SortHead title="Departure" onClick={() => handleSort("departure")} active={sortKey === "departure"} dir={sortDir} className="col-span-2" />
          <SortHead title="Duration" onClick={() => handleSort("duration")} active={sortKey === "duration"} dir={sortDir} className="col-span-2" />
          <SortHead title="Arrival" onClick={() => handleSort("arrival")} active={sortKey === "arrival"} dir={sortDir} className="col-span-2" />
          <SortHead title="Price" onClick={() => handleSort("price")} active={sortKey === "price"} dir={sortDir} className="col-span-2 justify-end pr-2" />
        </div>

        {sorted && sorted.length > 0 && sorted.map((f) => (
          <FlightCard key={f?.keyIndex} flight={f} handleBookNow={handleBookNow} handlFlightDeatils={handlFlightDeatils} openEye={openEye} handleShareSelection={handleShareSelection} isFlightSelected={isFlightSelected} FormData={FormData} />
        ))}
        {sorted.length == 0 && (
          <div
            className="h-10 flex items-center justify-center text-gray-500 ssssss"
          >
            No Flight Found
          </div>
        )}
      </main>
      <div className="">
        {/* Popup for selected flights */}

        {showProposalPopup && selectedFlights.length > 0 && (
          <FlightProposalShare
            selectedFlights={selectedFlights}
            setSelectedFlights={setSelectedFlights}
            handleShareSelection={handleShareSelection}
            FormData={FormData}
            setshowProposalPopup={setshowProposalPopup}
            onSetShare={onSetShare}
            user={user}
          />
        )}
      </div>
    </div>

  );
}

function SortHead({ title, onClick, active, dir, className = "" }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-1 ${className}`}
      title={`Sort by ${title}`}
    >
      <span>{title}</span>
      <ArrowUpDown
        size={16}
        className={`${active ? "text-blue-600" : "text-gray-400"
          } ${dir === "desc" ? "rotate-180" : ""}`}
      />
    </button>
  );
}

function FlightCard({ flight, handleBookNow, handlFlightDeatils, openEye, handleShareSelection, isFlightSelected, FormData }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-white rounded-lg shadow px-4 py-2 relative">
      {/* Checkbox for sharing - positioned absolutely at top left */}

      {/* <div className="absolute left-2 text-[14px] font-semibold bg-blue-500" style={{ top: '1px' }}>
        <span className="bg-gradient-to-r from-blue-500 to-red-500 bg-clip-text text-transparent">
          SPECIAL FARE
        </span>
      </div> */}
      {flight?.isSpecial > 0 && (
        <>
          {/* Left badge */}
          <div
            className="absolute bg-gradient-to-r from-blue-500 to-red-500 text-white text-xs font-semibold px-1 py-1 rounded shadow"
            style={{ top: "1px", left: "1px" }}
          >
            SPECIAL DEALS{" "}
          </div>

          {/* Right badge */}
          <div
            className="absolute to-red-500 text-green-600 text-[14px] font-semibold px-1 py-1"
            style={{ top: "1px", right: "150px" }}
          >
            <CurFt
              currency={flight.FareList[0]?.symbol || "INR"}
              price={Math.ceil(flight?.isSpecial) || 0}
            />{" "}
            Exclusive discounted
          </div>
        </>
      )}

      {/* Main row - match header grid for alignment */}
      <div className="grid grid-cols-12 items-center gap-2">
        {/* Airline */}
        <div className="col-span-12 md:col-span-4 flex items-center gap-3">
          <div className="flex items-center border rounded-lg hover:bg-gray-50">
            <input
              checked={isFlightSelected(flight, flight.FareList[0].PriceID)}
              value="1"
              type="checkbox"
              onClick={() => handleShareSelection(flight, flight.FareList[0].PriceID, !isFlightSelected(flight, flight.FareList[0].PriceID))}
              className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
          </div>
          <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center p-1">
            {/* airline logo */}
            <img src={`/AirlineLogo/${flight.AirlineCode}.png`} alt={flight.AirlineName} className="object-contain rounded-md w-full h-full" />
          </div>
          <div>
            <p className="font-medium leading-5">{flight.AirlineName}</p>
            <p className="text-xs text-gray-600">{flight.FlightNumber}</p>
          </div>
        </div>

        {/* Departure */}
        <div className="col-span-4 md:col-span-2 text-center md:text-left">
          <p className="text-2xl font-bold leading-6">{format(new Date(flight.FromUTCTime), "HH:mm")}</p>
          <p className="text-sm text-gray-600">{flight.SoCity}</p>
        </div>

        {/* Duration */}
        <div className="col-span-4 md:col-span-2 text-center md:text-left">
          <p className="font-medium">{flight.Duration}</p>
          <p className="text-sm text-gray-600">{flight.StopCount}</p>
        </div>

        {/* Arrival */}
        <div className="col-span-4 md:col-span-2 text-center md:text-left">
          <p className="text-2xl font-bold leading-6">{format(new Date(flight.ToUTCTime), "HH:mm")}</p>
          <p className="text-sm text-gray-600">{flight.DeCity}</p>
        </div>

        {/* Price + Actions */}
        <div className="col-span-12 md:col-span-2 flex items-center md:flex-col md:items-end gap-2 md:gap-3">
          {openEye && (
            <>
              <span className="text-sm font-normal text-blue-500">
                <CurFt currency={flight.FareList[0]?.symbol || "INR"} price={(flight?.FareList[0].agent_markup)} /> / <CurFt currency={flight.FareList[0]?.symbol || "INR"} price={(flight?.FareList[0].PublishedFare - flight?.FareList[0].agent_markup)} />
              </span>
            </>
          )}
          <div className="flex items-center justify-between w-full md:w-auto">
            {FormData.GroupRequest !== true && (
              <div className="text-md font-bold">
                {flight?.FareList[0]?.discountOffline > 0 && (
                  <>
                    <span className="inline-flex font-normal line-through items-center gap-2 text-sm text-red-600">
                      <CurFt currency={flight.FareList[0]?.symbol || "INR"} price={(flight?.FareList[0].PublishedFare + flight?.FareList[0]?.discountOffline)} />
                    </span>
                    <br />
                  </>
                )}

                <CurFt currency={flight.FareList[0]?.symbol || "INR"} price={(flight?.FareList[0].PublishedFare)} />
              </div>
            )}
            {flight?.FareList[0].PublishedFare < 0 && (
              <span className="inline-flex items-center gap-2 text-sm text-green-600">
                &nbsp; Refund
              </span>
            )}

            {/* <button
              id={flight.keyIndex}
              onClick={() => handleShareSelection(flight, flight.FareList[0].PriceID, !isFlightSelected(flight, flight.FareList[0].PriceID))}
              className={`ml-2 rounded-full border p-1 hover:bg-gray-50 ${isFlightSelected(flight, flight.FareList[0].PriceID) ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
                }`}
            >
              <Share2
                size={18}
                className={isFlightSelected(flight, flight.FareList[0].PriceID) ? "text-blue-600" : "text-gray-600"}
              />
            </button> */}
            {/* {!FormData?.reissueData && (
              <button
                id={flight.keyIndex}
                onClick={() => handleShareSelection(flight, !isFlightSelected(flight))}
                className={`ml-2 rounded-full border p-1.5 hover:bg-gray-50 ${isFlightSelected(flight) ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
                  }`}
              >
                <Share2
                  size={18}
                  className={isFlightSelected(flight) ? "text-blue-600" : "text-gray-600"}
                />
              </button>
            )} */}

          </div>
          {FormData.GroupRequest === true ? (
            <button onClick={() => handleBookNow(flight, flight.FareList[0])} className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-lg shadow">
              Request
            </button>
          ) : (
            <button onClick={() => handleBookNow(flight, flight.FareList[0])} className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-lg shadow">
              Book
            </button>
          )}

          {flight.FareList[0].is_flexi && (
            <p className="text-sm font-bold text-blue-600">
              Book at ₹{flight.FareList[0].BookAmt.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
            </p>
          )}
        </div>
      </div>

      {/* Info row: baggage, seats, layover  |  Flight Details (right) */}
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2 flex-wrap">
          {/* Baggage */}
          <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-blue-50 border-blue-200">
            <Ticket size={16} className="text-blue-600" />
            <span className="text-gray-700">
              {flight.FareList[0].fareIdentifier}
            </span>
          </span>
          {flight.FareList[0].SeatLeft > 0 && (
            <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-blue-50 border-blue-200">
              <Armchair size={16} className="text-blue-600" />
              <span className="text-gray-700">
                {flight.FareList[0].SeatLeft} Seats Left
              </span>
            </span>
          )}
          {flight.FareList[0].IsMeal ? (
            <span className="inline-flex items-center text-sm bg-white">
              <Utensils size={16} className="text-green-700" />
              <span className="text-green-700">&nbsp;Free Meal</span>
            </span>
          ) : (
            <span className="inline-flex items-center text-sm bg-white">
              <Utensils size={16} className="text-red-700" />
              <span className="text-red-700">&nbsp;Paid Meal</span>
            </span>
          )}
          <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-white">
            <BaggageClaim size={16} className="text-gray-600" />
            <span className="text-gray-600">{flight.FareList[0].Checkin}/{flight.FareList[0].Cabin}</span>
          </span>
          {flight.FareList[0].IsRefundable ? (
            <span className="inline-flex items-center text-sm bg-white">
              <TicketCheck size={16} className={`${flight.FareList[0].IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`} />
              <span className={`${flight.FareList[0].IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`}>
                {flight.FareList[0].RefundableTxt}
              </span>
            </span>
          ) : (
            <span className="inline-flex items-center text-sm bg-white">
              <TicketX size={16} className="text-red-600" />
              <span className="text-red-600">
                {flight.FareList[0].RefundableTxt}
              </span>
            </span>
          )}

          {flight.LAYOVERCity && flight.GroundTime > 0 && (
            <span className="inline-flex items-center gap-2 rounded-lg px-3 py-1 text-sm bg-blue-500 text-white">
              <Plane size={16} />
              Layover at {flight.LAYOVERCity}
            </span>
          )}

        </div>


        {flight.FareList.length > 1 && (
          <button onClick={() => setOpen((v) => !v)} className="text-sm font-medium text-[#1ea9e0] hover:underline">
            {open ? "Show Less" : `+${flight.FareList.length - 1} More fares`}
          </button>
        )}
        {flight.FareList[0].rewardEarns > 0 && (
          <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-xs bg-white">
            <img src="/coins.svg" className="w-5" />
            <span className="text-orange-600">Earn Reward {flight.FareList[0].rewardEarns}</span>
          </span>
        )}
        <button onClick={() => handlFlightDeatils(flight, flight.FareList[0])} className="text-sm font-medium text-[#1ea9e0] hover:underline">
          Flight Details
        </button>
      </div>

      {open && flight.FareList.map((value, Farekey) => (
        Farekey > 0 && (
          <div
            key={value.PriceID}
            className={`grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 items-center gap-2 p-2 mt-2 border-t relative`}
          >
            {/* Left side (3 cols combined) */}
            <div className="col-span-3 flex items-center gap-2 flex-wrap">
              <div className="flex items-center border rounded-lg hover:bg-gray-50">
                <input
                  checked={isFlightSelected(flight, value.PriceID)}
                  value="1"
                  type="checkbox"
                  onClick={() => handleShareSelection(flight, value.PriceID, !isFlightSelected(flight, value.PriceID))}
                  className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
              </div>
              <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-blue-50 border-blue-200">
                <Ticket size={16} className="text-blue-600" />
                <span className="text-gray-700">
                  {value.fareIdentifier}
                </span>
              </span>

              {value.SeatLeft > 0 && (
                <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-blue-50 border-blue-200">
                  <Armchair size={16} className="text-blue-600" />
                  <span className="text-gray-700">
                    {value.SeatLeft} Seats Left
                  </span>
                </span>
              )}

              {value.IsMeal ? (
                <span className="inline-flex items-center text-sm bg-white">
                  <Utensils size={16} className="text-green-700" />
                  <span className="text-green-700">&nbsp;Free Meal</span>
                </span>
              ) : (
                <span className="inline-flex items-center text-sm bg-white">
                  <Utensils size={16} className="text-red-700" />
                  <span className="text-red-700">&nbsp;Paid Meal</span>
                </span>
              )}

              <span className="inline-flex items-center text-sm bg-white">
                <BaggageClaim size={16} className="text-gray-700" />
                <span className="text-gray-700">{value.Checkin}/{value.Cabin}</span>
              </span>
              {value.IsRefundable ? (
                <span className="inline-flex items-center text-sm bg-white">
                  <TicketCheck size={16} className={`${value.IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`} />
                  <span className={`${value.IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`}>
                    {value.RefundableTxt}
                  </span>
                </span>
              ) : (
                <span className="inline-flex items-center text-sm bg-white">
                  <TicketX size={16} className="text-red-600" />
                  <span className="text-red-700">
                    {value.RefundableTxt}
                  </span>
                </span>
              )}
            </div>

            {/* Price + Details (1 col) */}
            <div className="text-right">
              {openEye && (
                <>
                  <span className="text-sm font-normal text-blue-500">
                    <CurFt currency={value?.symbol || "INR"} price={(value.agent_markup)} /> / <CurFt currency={value?.symbol || "INR"} price={(value.PublishedFare - value.agent_markup)} />
                  </span>
                  &nbsp;
                </>
              )}

              {FormData.GroupRequest !== true && (
                <button className="text-lg font-bold">
                  {value?.discountOffline > 0 && (
                    <>
                      <span className="inline-flex font-normal line-through items-center gap-2 text-sm text-red-600">
                        <CurFt currency={value?.symbol || "INR"} price={(value.PublishedFare + value?.discountOffline)} />
                      </span>
                      <br />
                    </>
                  )}
                  <CurFt
                    currency={value?.symbol || "INR"}
                    price={value.PublishedFare}
                  />
                </button>
              )}

              <br />
              <span
                onClick={() => handlFlightDeatils(flight, value)}
                className="text-sm font-medium text-[#1ea9e0] hover:underline cursor-pointer"
              >
                Details
              </span>

              {value.rewardEarns > 0 && (
                <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-xs bg-white">
                  <img src="/coins.svg" className="w-5" />
                  <span className="text-orange-600">Earn Reward {value.rewardEarns}</span>
                </span>
              )}
            </div>

            {/* Book button (1 col) */}
            <div className="text-right">

              {FormData.GroupRequest === true ? (
                <button
                  onClick={() => handleBookNow(flight, value)}
                  className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-1 rounded-lg shadow"
                >
                  Request
                </button>
              ) : (
                <button
                  onClick={() => handleBookNow(flight, value)}
                  className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-1 rounded-lg shadow"
                >
                  Book
                </button>
              )}
            </div>
          </div>
        )
      ))}
    </div>
  );
}
